import React, { useContext } from "react";
import ChangePasswordForm from "../../components/forms/ChangePassword";
import { changePassword } from "../../api/endpoints/password";
import { ApiResponse } from "../../api/apiResponse";
import { ToastContext } from "../../App";
import { useTranslation } from "react-i18next";

function ChangePasswordPage() {
  const toast = useContext(ToastContext);
  const LocalBasePath = "page.passwordReset";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  const onPressSetPassword = async (data: {
    newPassword: string;
    oldPassword: string;
  }) => {
    const response: ApiResponse = await changePassword({
      new_password: data.newPassword,
      old_password: data.oldPassword,
    });
    if (response.isSuccess) {
      toast?.success(t("passwordSetSuccessfully"));
    } else {
      response.errorMessages.forEach((errorMessage) => {
        toast?.error(errorMessage);
      });
    }
  };
  return <ChangePasswordForm onReset={onPressSetPassword} />;
}

export default ChangePasswordPage;
